import React from "react";
import FormPopup from "../FormPopup";
import { Button } from "@mui/material";

const ConfirmModal = ({
  open,
  setOpen,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Yes, Continue",
  cancelText = "No, Cancel",
  onConfirm,
  width = "500px",
  confirmColor = "#1976d2",
  cancelColor = "#666",
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <FormPopup open={open} setOpen={setOpen} width={width}>
      <div style={{ textAlign: "center" }}>
        <h4 style={{ fontWeight: "bold", marginBottom: "20px" }}>{title}</h4>
        <p style={{ marginBottom: "30px", fontSize: "16px" }}>{message}</p>
        <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
          <Button
            variant="contained"
            onClick={handleConfirm}
            style={{ backgroundColor: confirmColor, color: "white" }}
          >
            {confirmText}
          </Button>
          <Button
            variant="outlined"
            onClick={handleCancel}
            style={{ borderColor: cancelColor, color: cancelColor }}
          >
            {cancelText}
          </Button>
        </div>
      </div>
    </FormPopup>
  );
};

export default ConfirmModal;
